<mat-toolbar class="ori-elevation-z4 header">
  <mat-icon svgIcon="history"></mat-icon>
  <h3>
    {{ "historic.title" | translate }}
  </h3>
  <mat-icon class="icon icon-close" (click)="close()" color="primary" svgIcon="close"></mat-icon>
</mat-toolbar>
@if (history) {
  <mat-dialog-content class="dialog-content">
    <!--  SPEC: Select navigation tab if it exists-->
    <mat-tab-group oSticky mat-align-tabs="start" [selectedIndex]="navigation ? 0 : 1">
      <mat-tab [label]="'navigation.title' | translate" [disabled]="!navigation">
        @if (navigation) {
          <o-navigation-tree [navigation]="navigation" (onClick)="click($event)"></o-navigation-tree>
        }
      </mat-tab>
      <mat-tab [label]="'historic.title' | translate">
        <o-history-list [history]="history" (onClick)="click($event)"></o-history-list>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
}
